import React from 'react';

import { StyleSheet } from 'react-native';

import { A11yWrapper } from 'components/a11y-wrapper';
import { StoreSanityOrderEta } from 'components/sanity-store-order-eta/store-sanity-order-eta';
import { Halal } from 'components/ucl/svgs/Halal';
import { Box, Typography } from 'components/ui';
import { t } from 'state/intl/translations';
import { primitive, spacing } from 'styles/constants';

import { StoreCardDetailsProps } from '../types';

import { StoreCardMessages } from './store-card-messages';

export const StoreCardDetails: React.FC<StoreCardDetailsProps> = ({
  errorMessage,
  storeDetails,
  distanceComponent,
  hideDistanceInDetails,
  addressOnly = false,
}) => {
  const {
    restaurantStatus,
    serviceModesText,
    address,
    city,
    isHalal,
    accessInstructions,
    isNonTraditionalStore,
  } = storeDetails;
  const statusColor = restaurantStatus.isWithinOneHourOfClose
    ? primitive.$chkingOrange
    : restaurantStatus.isOpen
    ? primitive.$crunchyGreen
    : primitive.$fieryRed;

  return (
    <Box style={styles.container}>
      {address && (
        <Box focusable={false}>
          <Box style={styles.addressRow}>
            <Typography variant="headerThree" focusable={false} style={styles.address}>
              {address}
            </Typography>
            {!hideDistanceInDetails ? (
              <StoreSanityOrderEta store={storeDetails.restaurant} />
            ) : null}
          </Box>
          {!addressOnly ? (
            <Box style={styles.statusRow}>
              <Box style={styles.cityWrapper}>
                <Typography variant="copyTwo">{city}</Typography>
                <Typography>{' • '}</Typography>
              </Box>
              <Box>
                <A11yWrapper style={styles.statusA11yWrapper}>
                  <Typography
                    variant="copyOne"
                    fontSize="sm"
                    fontFamily="heading"
                    focusable
                    color={statusColor}
                    style={styles.status}
                  >
                    {restaurantStatus.text}
                  </Typography>
                </A11yWrapper>
              </Box>
            </Box>
          ) : null}
        </Box>
      )}
      {!addressOnly && isHalal ? <Halal title={t('isHalalTitle')} /> : null}
      {!addressOnly && serviceModesText ? (
        <Box focusable style={styles.serviceModesRow}>
          <Typography variant="copyTwo">{serviceModesText}</Typography>
          {!hideDistanceInDetails ? distanceComponent : null}
        </Box>
      ) : null}

      {!addressOnly ? (
        <StoreCardMessages
          errorMessage={errorMessage}
          accessInstructions={isNonTraditionalStore ? accessInstructions : ''}
        />
      ) : null}
    </Box>
  );
};

const styles = StyleSheet.create({
  address: {
    marginBottom: spacing.$1,
    marginTop: spacing.$1,
  },
  addressRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  cityWrapper: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  container: {
    flex: 1,
    overflow: 'hidden',
    position: 'relative',
  },
  serviceModesRow: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  statusA11yWrapper: {
    alignItems: 'center',
  },
  status: {
    marginTop: spacing.$1,
  },
  statusRow: {
    alignItems: 'baseline',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    width: '100%',
  },
});
